import Layout from '@/components/feature/Layout';

export default function NormativaPage() {
  return (
    <Layout>
      {/* Hero header with image background */}
      <div className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=official%20legal%20documents%20with%20official%20stamps%20and%20signatures%20on%20a%20wooden%20desk%2C%20bolivian%20flag%20in%20soft%20background%2C%20warm%20natural%20lighting%2C%20professional%20editorial%20photography%2C%20clean%20neutral%20tones%2C%20simple%20composition%20with%20space%20for%20text&width=1800&height=600&seq=normativa-hero-regulations&orientation=landscape"
            alt="Documentos de normativa legal"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
        </div>
        <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-300 mb-3">
            Legal
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Normativa
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Marco legal y reglamentario del Comité de Desarrollo San Jacinto Norte Zona Oeste.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-8">
            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                1. Personería Jurídica
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                El Comité de Desarrollo San Jacinto Norte Zona Oeste (CODESAJAN) posee personería jurídica propia otorgada mediante Resolución Administrativa N° 056/2011 de la Gobernación del Departamento de Tarija. Esta personería nos confiere autonomía legal, administrativa y operativa para la gestión independiente de nuestros servicios, con reglamentación interna propia aprobada por asamblea general de afiliados.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                2. Naturaleza Jurídica
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                CODESAJAN es un comité de desarrollo con personería jurídica independiente. No cumplimos funciones como comunidad dentro del ámbito rural. Las comunidades de San Jacinto Norte y San Jacinto Sud existen como entidades territoriales separadas. Nuestra organización, por nuestra personería jurídica, somos independientes, poseemos nuestra propia reglamentación y autonomía de gestión. Abarcamos dos zonas: área rural y área urbana de San Jacinto Norte Zona Oeste.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                3. Reglamento Interno
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                El comité cuenta con un reglamento interno aprobado por la asamblea general de afiliados, que establece las normas de funcionamiento, derechos y obligaciones de los afiliados, estructura de la directiva, régimen de tarifas por el servicio de agua, procedimientos para altas y bajas de afiliados, y mecanismos de resolución de controversias. Este reglamento es de cumplimiento obligatorio para todos los afiliados al comité.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                4. Estructura de la Directiva
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                La directiva de CODESAJAN está conformada por afiliados elegidos democráticamente en asamblea general, conforme al reglamento interno vigente. Los cargos y períodos de gestión se rigen por lo dispuesto en la normativa interna aprobada. La directiva es responsable de la administración transparente de los recursos, la prestación continua del servicio de agua y la representación legal del comité ante entidades públicas y privadas.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                5. Marco Normativo Aplicable
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Nuestra actividad se enmarca en la normativa boliviana vigente en materia de organizaciones territoriales, servicios básicos, recursos hídricos y protección del medio ambiente. Cumplimos con las disposiciones de la Gobernación del Departamento de Tarija, el Gobierno Municipal y demás entidades reguladoras competentes en el ámbito de nuestra operación.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                6. Información Detallada
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Para acceder al texto completo de nuestra normativa, el reglamento interno detallado, la Resolución Administrativa N° 056/2011, o cualquier otro documento legal relacionado con la constitución y funcionamiento del comité, le solicitamos comunicarse directamente con la directiva de CODESAJAN en nuestras oficinas durante el horario de atención.
              </p>
            </section>

            <div className="mt-12 p-6 rounded-xl bg-accent-50 border border-accent-100">
              <div className="flex items-start gap-3">
                <i className="ri-information-line text-accent-600 text-lg w-5 h-5 flex items-center justify-center shrink-0 mt-0.5"></i>
                <div>
                  <p className="text-sm font-semibold text-foreground-950 mb-1">Información Importante</p>
                  <p className="text-sm text-foreground-600">
                    Este documento presenta un resumen general de nuestra normativa. Para información legal detallada, documentación oficial completa y reglamentación específica del comité, le solicitamos contactar directamente con la directiva de CODESAJAN en nuestras oficinas durante el horario de atención: Lunes a Viernes de 08:00 a 16:30 y Sábados de 08:00 a 12:00.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}